export const SET_COMBATANT_NAME = 'SET_COMBATANT_NAME';
export const SET_COMBATANT_HP = 'SET_COMBATANT_HP';
export const SET_COMBATANT_AC = 'SET_COMBATANT_AC';
export const SET_COMBATANT_PROFICIENCY = 'SET_COMBATANT_PROFICIENCY';
export const SET_COMBATANT_STRENGTH = 'SET_COMBATANT_STRENGTH';
export const SET_COMBATANT_DEXTERITY = 'SET_COMBATANT_DEXTERITY';
export const SET_COMBATANT_CONSTITUTION = 'SET_COMBATANT_CONSTITUTION';
export const SET_COMBATANT_WISDOM = 'SET_COMBATANT_WISDOM';
export const SET_COMBATANT_INTELLIGENCE = 'SET_COMBATANT_INTELLIGENCE';
export const SET_COMBATANT_CHARISMA = 'SET_COMBATANT_CHARISMA';
export const SET_COMBATANT_ACTIONS = 'SET_COMBATANT_ACTIONS';
export const SET_COMBATANT_MSG = 'SET_COMBATANT_MSG';
export const SET_DNDBEYOND_URL = 'SET_DNDBEYOND_URL'